module.exports = __webpack_public_path__ + "static/media/grantspass-small-placeholder.d47424b3.webp";